import React, { useEffect } from 'react'
import {
  acquireBottomImmersive,
  releaseBottomImmersive,
} from '../utils/flutterStatusBar'
import Gap from './Gap'

interface ContactSyncSkipModalProps {
  isOpen: boolean
  onCancel: () => void
  onConfirmSkip: () => void
}

const ContactSyncSkipModal: React.FC<ContactSyncSkipModalProps> = ({
  isOpen,
  onCancel,
  onConfirmSkip,
}) => {
  // 센터 다이얼로그: 하단 SafeArea 해제 → dim이 홈 인디케이터까지 덮음
  useEffect(() => {
    if (!isOpen) return
    acquireBottomImmersive()
    return () => releaseBottomImmersive()
  }, [isOpen])

  if (!isOpen) {
    return null
  }

  return (
    <>
      <div
        className="fixed inset-0 z-[1050] bg-black bg-opacity-40"
        onClick={onCancel}
      />

      <div className="fixed inset-0 z-[1050] flex items-center justify-center px-18px">
        <div
          className={`
            w-full
            max-w-[333px]
            rounded-12px
            bg-white
            px-18px
            pt-24px
            pb-24px
            flex
            flex-col
            items-center
          `}
          onClick={(e) => e.stopPropagation()}
        >
          <div className="flex flex-col items-center w-full">
            <p
              className={`
                font-pretendard
                font-700
                text-16px
                text-center
                text-brown-80%-main
              `}
            >
              연락처 연동을 하지 않으면
            </p>
            <Gap height={8} />
            <p
              className={`
                font-pretendard
                font-700
                text-16px
                text-center
                text-brown-80%-main
              `}
            >
              친구 추천 기능이 제한됩니다
            </p>
          </div>

          <Gap height={24} />

          <div className="w-full flex gap-8px">
            <button
              type="button"
              onClick={onCancel}
              className={`
                flex-1
                h-44px
                rounded-12px
                bg-472410-10%
                font-pretendard
                font-700
                text-16px
                text-brown-80%-main
                flex
                items-center
                justify-center
              `}
            >
              취소
            </button>
            <button
              type="button"
              onClick={onConfirmSkip}
              className={`
                flex-1
                h-44px
                rounded-12px
                bg-brown-80%-main
                font-pretendard
                font-bold
                text-16px
                text-white
                flex
                items-center
                justify-center
              `}
            >
              건너뛰기
            </button>
          </div>
        </div>
      </div>
    </>
  )
}

export default ContactSyncSkipModal
